import React, {  useState } from "react";
import {

    CModal,
    CModalBody,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { addAdminRequest } from "../redux/adminDispatcher";
import { hideAddAdminModal, showAddAdminModal } from "../redux/adminModalDispatcher";

const ChnagePassword = ({
    buttonLabel = "Change Password",
    adminData = {},
}) => {
    const dispatch = useDispatch();

    const [isModalVisible, setIsModalVisible] = useState(false); // Local State

    const [password, setPassword] = useState("");


    const resetForm = () => {
        setPassword("");
    };

    // Handle Chnage Admin Password Submission
    const handleChnageAdminPassword = () => {

        if (password.trim() === "") {
            alert("Admin password is required");
            return;
        }

        var data = {

            "name": adminData.name,
            "email": adminData.email,
        };

        data['password'] = password;

        data['id'] = adminData.id;





        dispatch(addAdminRequest(data));
        setPassword("");
        setIsModalVisible(false);
        dispatch(hideAddAdminModal());
    };

    return (
        <div>
            {/* Button to Open Modal */}
            <button
                onClick={() => {
                    resetForm();
                    setIsModalVisible(true)
                    dispatch(showAddAdminModal())

                }}
                style={{
                    backgroundColor: "#1b87f4",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "4px",
                    fontSize: "10px",
                    minWidth: "60px",
                    height: "24px",  // Increased height
                    padding: "2px 5px", // Added padding
                    display: "flex",
                    alignItems: "center",
                    // alignSelf:"end",
                    justifyContent: "center",
                }}
            >{buttonLabel}</button>

            {/* Modal */}
            <CModal
                alignment="center"
                visible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                className="attributemodal"

            >
                <CModalBody className="main-container createAdmin" >
                    <div className="main-container createAdmin">
                        {/* Close Button */}
                        <div className="cross-btn-div d-flex">
                            <img
                                onClick={() => setIsModalVisible(false)}
                                src={crossButton}
                                alt="close"
                                className="cross-button"
                            />
                        </div>

                        <form onSubmit={(e) => e.preventDefault()} className="login-form">
                            <div className="mb-4">
                                <h4
                                    className="h4 fw-bold"
                                    style={{ color: "#007bff", textAlign: "center" }}
                                >
                                    <b>{"Change Password"}</b>
                                </h4>
                            </div>

                         

                        

                            { <div className="mb-3 input-login-box">
                                <input
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    name="password"
                                    type="text"
                                    className="form-control login-input"
                                    placeholder="Enter admin password"
                                />
                            </div>}




                            {/* Submit Button */}
                            <button
                                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                                type="button"
                                onClick={handleChnageAdminPassword}
                            >
                                {"Change Password"}
                            </button>
                        </form>
                    </div>
                </CModalBody>
            </CModal>
        </div>
    );
};

export default ChnagePassword;
